import { Card } from '@campgladiator/cgui-core.atoms.card'
import { ProgressBar } from '@campgladiator/cgui-core.atoms.progress-bar'
import { Heading, Paragraph } from '@campgladiator/cgui-core.atoms.typography'

const { REACT_APP_CDN_URL } = process.env

const CheckinCounter = ({ totalCheckIns, minCheckIns }) => {
  const isChallengeGoalMet = totalCheckIns >= minCheckIns
  const checkIns = isChallengeGoalMet ? minCheckIns : totalCheckIns
  const percentCompleted = (checkIns / minCheckIns) * 100

  return (
    <Card className="checkin-counter" raised>
      <div className="checkin-counter__header-box">
        <img
          className="checkin-counter__header-img"
          src={`${REACT_APP_CDN_URL}megaphone.svg`}
          alt=""
        />
        <div>
          <Heading type="h4">
            Check-in:{' '}
            <span className="checkin-counter__header--gladiator-light">
              {totalCheckIns} / {minCheckIns}
            </span>
          </Heading>
          <Paragraph>
            {isChallengeGoalMet ? (
              <>
                Your hard work deserves a celebration & a FREE shirt! Your shirt
                will be mailed to the address on your account.
              </>
            ) : (
              <>
                Complete at least {minCheckIns} check-ins, and score a FREE
                shirt!
              </>
            )}
          </Paragraph>
        </div>
      </div>
      <ProgressBar
        className="checkin-counter__progress"
        barFillPct={percentCompleted}
        shape="rounded"
        progressColor="gladiator-light"
        textPosition="bottom"
        titleText="0"
        progressText={minCheckIns}
      />
    </Card>
  )
}

export default CheckinCounter
